module.exports = __webpack_public_path__ + "media/es_slide7_audio.c804c80a.mp4";